import {gql} from "@irati/utils/gql"

export default gql`
  fragment fullProductSettings on ProductSettings {
    uuid
    businessId
    teamId

    medicalSettings {
      ...fullMedicalSettings
    }
    perksSettings {
      ...fullPerkSettings
    }
    recognitionSettings {
      ...fullRecognitionSettings
    }
    walletSettings {
      ...fullWalletSettings
    }
    rewardSettings {
      ...fullRewardSettings
    }
    cycleToWorkSettings {
      ...fullCycleToWorkSettings
    }
  }

  fragment fullPerkSettings on ProductSettingsPerks {
    meatadata {
      createdAt
      createdBy
      updatedAt
      updatedBy
    }

    blacklistedPerks
    blacklistedTags
    packageId
    packageAddonIds
    whitelistedPerks
    whitelistedTags
    regionId
    ttAllowance
    ttTopupIntervalCount
    ttTopupInterval
  }

  fragment fullMedicalSettings on ProductSettingsMedical {
    tier
  }

  fragment fullCycleToWorkSettings on ProductSettingsCycleToWork {
    tier
  }

  fragment fullWalletSettings on ProductSettingsWallet {
    canPurchasePoints
    canRequestPoints
    canApprovePointsRequest
  }

  fragment fullRecognitionSettings on ProductSettingsRecognition {
    meatadata {
      createdAt
      createdBy
      updatedAt
      updatedBy
    }

    rewardPackageId
    attachReward
    createPoll
    sharing
    viewReward
    sendToEveryone
    sendToTeams
  }

  fragment fullRewardSettings on ProductSettingsReward {
    business {
      ... on ProductSettingsRewardDefault {
        defaultMin
        defaultMax
      }
      ... on ProductSettingsRewardSet {
        setMin
        setMax
      }
    }
  }
`
